module.exports = __webpack_public_path__ + "img/btn2.dcb89b72.png";